import { render, staticRenderFns } from "./UnitsListModal.vue?vue&type=template&id=dc5e0984&scoped=true"
import script from "./UnitsListModal.vue?vue&type=script&lang=js"
export * from "./UnitsListModal.vue?vue&type=script&lang=js"
import style0 from "./UnitsListModal.vue?vue&type=style&index=0&id=dc5e0984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5e0984",
  null
  
)

export default component.exports